/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Feat1_TitleInputs */

const es_exp_mk_feat1_title = /** @type {(inputs: Exp_Mk_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra una salida`)
};

const gl_exp_mk_feat1_title = /** @type {(inputs: Exp_Mk_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atopa unha saída`)
};

const en_exp_mk_feat1_title = /** @type {(inputs: Exp_Mk_Feat1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find a trip`)
};

/**
* | output |
* | --- |
* | "Find a trip" |
*
* @param {Exp_Mk_Feat1_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_feat1_title = /** @type {((inputs?: Exp_Mk_Feat1_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Feat1_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_feat1_title(inputs)
	if (locale === "en") return en_exp_mk_feat1_title(inputs)
	return es_exp_mk_feat1_title(inputs)
});